import { CreateLogger } from './logger';

const logger = CreateLogger('services/auth');
const ACCESS_TOKEN_KEY = 'access_token';
const LEGACY_TOKEN_KEY = 'token';
// Quando o access expira (epoch ms). Salvo no setAuth/refresh; lido pelo
// api.js pra decidir entre fazer request direto ou refrescar antes.
const ACCESS_EXPIRES_AT_KEY = 'access_expires_at';

export function GetAccessExpiresAt() {
    const raw = localStorage.getItem(ACCESS_EXPIRES_AT_KEY);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
}

export function SetAccessExpiresAt(epochMs) {
    if (typeof epochMs === 'number' && Number.isFinite(epochMs)) {
        localStorage.setItem(ACCESS_EXPIRES_AT_KEY, String(epochMs));
    } else {
        localStorage.removeItem(ACCESS_EXPIRES_AT_KEY);
    }
}

export function ClearAccessExpiresAt() {
    localStorage.removeItem(ACCESS_EXPIRES_AT_KEY);
}

class AuthService {
    constructor() {
        this.tokenExpiredCallbacks = [];
    }

    onTokenExpired(callback) {
        this.tokenExpiredCallbacks.push(callback);
    }

    removeTokenExpiredCallback(callback) {
        this.tokenExpiredCallbacks = this.tokenExpiredCallbacks.filter((cb) => cb !== callback);
    }

    notifyTokenExpired() {
        logger.warn('token_expired_notifying_callbacks', {
            callbacksCount: this.tokenExpiredCallbacks.length,
        });

        this.tokenExpiredCallbacks.forEach((callback) => {
            try {
                callback();
            } catch (error) {
                logger.error('token_expired_callback_failed', {
                    error: { name: error.name, message: error.message },
                });
            }
        });
    }

    isAuthenticated() {
        return Boolean(localStorage.getItem(ACCESS_TOKEN_KEY) || localStorage.getItem(LEGACY_TOKEN_KEY));
    }

    logout() {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        localStorage.removeItem(LEGACY_TOKEN_KEY);
        localStorage.removeItem(ACCESS_EXPIRES_AT_KEY);
        localStorage.removeItem('user');
        window.location.href = '/login';
    }

    redirectToLogin() {
        this.logout();
    }

    getUser() {
        try {
            const user = localStorage.getItem('user');
            return user ? JSON.parse(user) : null;
        } catch (error) {
            logger.error('parse_user_from_storage_failed', {
                error: { name: error.name, message: error.message },
            });
            return null;
        }
    }

    setAuth(token, user) {
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
        localStorage.removeItem(LEGACY_TOKEN_KEY);

        if (user) {
            localStorage.setItem('user', JSON.stringify(user));
        }
    }
}

const authService = new AuthService();
export default authService;
